<template>
  <vs-wrapper>
    <div>
      <vs-heading>Inventory</vs-heading>
    </div>
    <div class="inventory-group-picker" v-if="props.modelValue.length > 0">
      <div
        v-for="(item, index) in props.modelValue"
        :key="item._uniqueId"
        class="inventory-item-row"
      >
        <job-inventory-and-quantity-picker
          class="inventory-item-picker"
          :model-value="item"
          :disable-inventory-sub-types="getDisabledInventorySubTypes(index)"
          allow-remove-inventory
          :show-arrow="false"
          @update:modelValue="updateInventoryItem(index, $event)"
          @remove-inventory-item="removeInventoryItem(index)"
        />
      </div>
    </div>

    <div v-else>
      <vs-text type="subdued">No inventory at this location yet</vs-text>
    </div>
    <div class="pt-2 pb-7">
      <v-tooltip :disabled="canAddMoreItems" top max-width="400px">
        <template #activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on">
            <vs-button
              label="Add inventory item"
              small
              type="secondary"
              data-test="add-inventory-item-button"
              :disabled="!canAddMoreItems"
              @click="addInventoryItem"
            />
          </span>
        </template>
        <span>Fill out existing empty inventory item first before adding the new one</span>
      </v-tooltip>
    </div>
  </vs-wrapper>
</template>

<script lang="ts" setup>
import JobInventoryAndQuantityPicker from '../tickets/StopsAndInventories/InventoryPickers/JobInventoryAndQuantityPicker.vue'
import VsHeading from '@/components/vision/VsHeading.vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import VsText from '@/components/vision/VsText.vue'
import VsButton from '@/components/vision/VsButton.vue'
import { InventoryPickerItem } from '../tickets/StopsAndInventories/InventoryPickers'
import { v4 } from 'uuid'
import { computed } from 'vue'

const props = defineProps<{
  modelValue: InventoryPickerItem[]
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: InventoryPickerItem[]): void
}>()

const addInventoryItem = () => {
  const hasEmptyItem = props.modelValue.some((item) => item.inventorySubTypeId === null)

  if (!hasEmptyItem) {
    const newItems = [
      ...props.modelValue,
      {
        inventorySubTypeId: null,
        quantity: null,
        _uniqueId: v4(),
        id: null,
        autofocus: true,
      },
    ]
    emit('update:modelValue', newItems)
  }
}

const updateInventoryItem = (index: number, updatedItem: InventoryPickerItem) => {
  const newItems = [...props.modelValue]
  newItems[index] = updatedItem
  emit('update:modelValue', newItems)
}

const removeInventoryItem = (index: number) => {
  const newItems = props.modelValue.filter((_, i) => i !== index)
  emit('update:modelValue', newItems)
}
const getDisabledInventorySubTypes = (currentIndex: number): number[] => {
  return props.modelValue
    .filter((item, index) => index !== currentIndex && item.inventorySubTypeId !== null)
    .map((item) => item.inventorySubTypeId!)
}

const canAddMoreItems = computed(() => {
  return !props.modelValue.some((item) => item.inventorySubTypeId === null)
})
</script>

<style scoped>
.inventory-group-picker {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.inventory-item-row {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
}
.inventory-item-picker {
  flex: 1;
}
</style>
